'use client';

import { ThemeProvider } from '@mui/material';
import { ReactNode } from 'react';
import theme from '@/shared/theme/theme';

export default function MuiProvider({ children }: { children: ReactNode }) {
    return (
        <ThemeProvider theme={theme}>
            {children}
        </ThemeProvider>
    );
}